import { useNavigate } from 'react-router-dom';
import CustomersTab from './CustomersTab';
import Button from '../components/Button';
import { useRole } from '../hooks/useRole';

export default function Customers() {
  const navigate = useNavigate();
  const { isEditor } = useRole();

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Customers
          </h1>
          <p className="text-base md:text-lg text-gray-600">
            View all customers and their battery packs
          </p>
        </div>
        {isEditor && (
          <Button
            variant="primary"
            onClick={() => navigate('/customers/new')}
            className="md:w-auto w-full"
          >
            + Add New Customer
          </Button>
        )}
      </div>
      <CustomersTab />
    </div>
  );
}

